<div class="edit-main d-flex flex-column justify-content-center">
  <div class="header mt-3 mb-3">
    <h2 class="d-flex row modal-title text-center heading2">
      <div class="col-11 pl-4">
        <app-with-tooltip [showHelpCursor]="true">
          {{ site?.siteName }}
        </app-with-tooltip>
      </div>

      <div (click)="closeDialog()">
        <img src="/assets/svg/ico-hamburger-close.svg" class="pointer-cursor" />
      </div>
    </h2>

    <br />
    <h1 class="text-center heading1">{{ "EDIT_SITE" | translate }}</h1>
  </div>

  <form [formGroup]="formGroup" (ngSubmit)="onUpdateSiteHandler(true)">
    <div class="form-group rounded-top form-container p-2" cdkScrollable>
      <mat-form-field appearance="fill" class="w-100 mb-2">
        <mat-label>{{ "SITE_NAME" | translate }}</mat-label>
        <input
          matInput
          minlength="1"
          [placeholder]="'ENTER_SITE_NAME' | translate"
          formControlName="name"
        />
        <mat-error *ngIf="formGroup?.controls?.name?.errors?.whitespace">{{
          "EXTRA_WHITE_SPACES_ARE_NOT_SUPPORTED" | translate
        }}</mat-error>
        <mat-error *ngIf="formGroup?.controls?.name?.errors?.required">{{
          "YOU_MUST_ENTER_SITE_NAME" | translate
        }}</mat-error>

        <mat-error *ngIf="formGroup?.controls?.name?.errors?.minlength">{{
          commonService.stringInterPolation(
            "MINIMUM_OF_CHARACTERS" | translate,
            "1"
          )
        }}</mat-error>
        <mat-error *ngIf="formGroup?.controls?.name?.errors?.maxlength">
          {{
            commonService.stringInterPolation(
              "MAXIMUM_OF_CHARACTERS" | translate,
              "50"
            )
          }}
        </mat-error>
        <mat-error
          *ngIf="
            formGroup?.controls?.name?.errors?.entityName &&
            !formGroup?.controls?.name?.errors?.required &&
            !formGroup?.controls?.name?.errors?.whitespace &&
            !formGroup?.controls?.name?.errors?.minlength &&
            !formGroup?.controls?.name?.errors?.maxlength
          "
          >{{ "YOU_MUST_ENTER_VALID_SITE_NAME" | translate }}</mat-error
        >
      </mat-form-field>

      <mat-form-field appearance="fill" class="w-100 mb-2">
        <mat-label>{{ "ADDRESS" | translate }}</mat-label>
        <input
          matInput
          [placeholder]="'ENTER_ADDRESS' | translate"
          formControlName="address"
          [matAutocomplete]="auto"
        />

        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
          <mat-option
            *ngFor="let suggestion of filteredSuggestions | async"
            [value]="suggestion"
          >
            {{ suggestion }}
          </mat-option>
        </mat-autocomplete>

        <mat-error>
          <span *ngIf="formGroup?.controls?.address?.errors?.whitespace">{{
            "EXTRA_WHITE_SPACES_ARE_NOT_SUPPORTED" | translate
          }}</span>
          <span *ngIf="formGroup?.controls?.address?.errors?.required">{{
            "YOU_MUST_ENTER_ADDRESS" | translate
          }}</span>
          <span *ngIf="formGroup?.controls?.address?.errors?.minlength">{{
            commonService.stringInterPolation(
              "MINIMUM_OF_CHARACTERS" | translate,
              formGroup?.controls?.address?.errors?.minlength.requiredLength?.toString()
            )
          }}</span>
          <span
            *ngIf="
              formGroup?.controls?.address?.errors?.maxlength &&
              !formGroup?.controls?.address?.errors?.whitespace
            "
            >{{
              commonService.stringInterPolation(
                "MAXIMUM_OF_CHARACTERS" | translate,
                "255"
              )
            }}</span
          >
          <span
            *ngIf="
              formGroup?.controls?.address?.errors?.addressPattern &&
              !formGroup?.controls?.address?.errors?.required &&
              !formGroup?.controls?.address?.errors?.whitespace &&
              !formGroup?.controls?.address?.errors?.maxlength
            "
            >{{ "YOU_MUST_ENTER_VALID_SITE_ADDRESS" | translate }}</span
          >
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="fill" class="w-100 mb-2">
        <mat-label>{{ "TIME_ZONE" | translate }}</mat-label>
        <input
          matInput
          [placeholder]="'SITE_REGION' | translate"
          formControlName="siteZone"
        />
      </mat-form-field>

      <button
        type="button"
        (click)="openAddBuilding()"
        class="add-button px-5 py-3 mt1 mb-4 w-100"
        [controlDisabled]="[PageName.Building, CONSTANTS.CREATE]"
        [disabledCheck]="!formGroup.valid && !formGroup.disabled"
      >
        <strong> {{ "ADD_BUILDING" | translate }} </strong>
      </button>

      <div
        *ngFor="
          let building of buildings | sortBy : 'buildingName' : 'asc';
          let i = index
        "
        class="mb-4"
      >
        <div
          (click)="editBuilding(building?.buildingId, building?.buildingName)"
          role="button"
        >
          <app-list-items [name]="building?.buildingName"></app-list-items>
        </div>
      </div>
    </div>
    <div *ngIf="site?.buildings" class="blur-effect-container">
      <div class="w-100 blur-effect"></div>
    </div>

    <input
      type="file"
      id="fileUpload"
      name="fileUpload"
      accept=".jpeg,.png,.jpg"
      class="d-none"
    />
    <a
      id="site-photo-download"
      class="d-none"
      href="{{ sitePhotoURL }}"
      target="_blank"
      download
    ></a>

    <div class="row">
      <div class="col-12 my-1">
        <button
          class="btn btn-danger px-3 w-100 done-btn"
          type="submit"
          tabindex="0"
          [controlDisabled]="[PageName.Site, CONSTANTS.UPDATE]"
          [disabledCheck]="!formGroup.valid"
        >
          {{ "DONE" | translate }}
        </button>
      </div>
    </div>
  </form>
</div>
